import React, { useEffect, useRef } from "react";
const ListenOutsideClick = _ref => {
  let {
    children,
    onOuterClick
  } = _ref;
  const innerRef = useRef(null);
  useEffect(() => {
    const handleClick = event => {
      if (innerRef.current && !innerRef.current.contains(event.target)) {
        onOuterClick(event);
      }
    };
    if (innerRef.current) {
      document.addEventListener("click", handleClick);
    }
    return () => document.removeEventListener("click", handleClick);
  }, [onOuterClick, innerRef]);
  return /*#__PURE__*/React.createElement("div", {
    ref: innerRef
  }, children);
};
export default ListenOutsideClick;